import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { facilityStayAction } from 'src/redux/actions/constant';
import facilityStayService from 'src/services/apiServices/facilityStayService';

const { REQUEST_UPDATE_FACILITY_STAY, SUCCESS_UPDATE_FACILITY_STAY, FAILURE_UPDATE_FACILITY_STAY,UPDATE_FACILITY_LOADING } =
  facilityStayAction;

function* updateFacilitiesStay(action: any): SagaReturnType<any> {
  try {
    yield put({type:UPDATE_FACILITY_LOADING})
    const response = yield call(facilityStayService.updateFacilityStay, action.payload);
    if (response?.status === 200) {
      yield put({ type: SUCCESS_UPDATE_FACILITY_STAY, payload: response });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: FAILURE_UPDATE_FACILITY_STAY, payload: error });
  }
}

function* updateFacilitiesStaySaga() {
  yield takeEvery(REQUEST_UPDATE_FACILITY_STAY, updateFacilitiesStay);
}

export default updateFacilitiesStaySaga;
